export enum DeployedSinglePathMissionCloudState {
  LaunchRequest = 0,
  Pending = 1,
  DeployedRunning = 2,
  Canceled = 3,
  ConfirmCompleted = 4
}
export enum DeployedLeaderFollowerMissionCloudState {
  LaunchRequest = 0,
  Pending = 1,
  DeployedRunning = 2,
  Canceled = 3,
  Completed = 4
}
